import { useSuspenseQuery } from "@tanstack/react-query";
import { route } from "../../../../../../shim/jsbridge";
import { queryOptions } from "../../../../../search/hooks";
import { Analysis, FireEyeNetworks, JoeNetworks } from "../../../../@types";
import { CapeNetworks } from "../../../../@types/cape/";
import { CuckooNetworks } from "../../../../@types/cuckoo";
import api from "../../../../api";
import { sampleReportKeys } from "../../../../queryKeys";

const useGetNetworkData = <
  T extends CuckooNetworks | CapeNetworks | FireEyeNetworks | JoeNetworks
>(
  hash: string,
  type: T,
  analysis: Analysis
) => {
  const endpoint = route(`api_${analysis}_network_${type}`, [hash]);

  const { data } = useSuspenseQuery({
    ...queryOptions,
    queryKey: sampleReportKeys.networkData(endpoint),
    queryFn: () => api.getDynamicAnalysisData<Array<unknown>>(endpoint),
    select: ({ data: networkData }) => networkData
  });

  return { data };
};

export default useGetNetworkData;
